/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";
import dateUtils from "utils/date";

const ProductCategoriesTable = ({
  productCategories,
  companyURL,
  onClickDelete
}) => {
  const TableOrNotFound = () => {
    if (productCategories.loading) {
      return "is Loading";
    }
    if (isEmpty(productCategories.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Parent Category</th>
            <th>Weight</th>
            <th>Released at</th>
            <th>Expired at</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {productCategories.data.map(productCategory => (
            <tr key={productCategory.id}>
              <td>{productCategory.id}</td>
              <td>{productCategory.name}</td>
              <td>
                {productCategory.parent ? productCategory.parent.name : ""}
              </td>
              <td>{productCategory.weight}</td>
              <td>{dateUtils.phpFormatToJS(productCategory.released_at)}</td>
              <td>{dateUtils.phpFormatToJS(productCategory.expired_at)}</td>
              <td>
                {productCategory.status ? productCategory.status.status : ""}
              </td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/product-categories/${productCategory.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Update</span>
                  </Link>
                  <a
                    onClick={onClickDelete(productCategory.id)}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default ProductCategoriesTable;
